<section class="dialog-content-wrapper">
    <div class="uscb-layout-row uscb-bg-primary uscb-color-white">
        <span class="vcenter uscb-flex uscb-padding-TB-0 uscb-padding-LR-8">{{addSurveyDialogData?.title || 'Add Survey'}}</span>
        <span class="vcenter">
            <mat-icon (click)="close(true)" (keyup.enter)="close(true)" tabindex="0" aria-hidden="false">close</mat-icon>
        </span>
    </div>

    @if (!isSuccess()) {
    <mat-dialog-content>
        <div class="my-dialog-content">
            <h5 class="uscb-padding-L-8">AUTHENTICATION CODE &nbsp;<span class="red-text"><b>*</b></span></h5>

            @if (currentAddSurveyError()) {
            <div class="red-text-darker uscb-padding-L-8" role="alert">
                {{currentAddSurveyError()}}
                @if (!isHideHowDoIMsg()) {
                <span class="uscb-padding-L-8" role="alert">Please visit the <a (click)="showHelpModal()" (keyup.enter)="showHelpModal()" tabindex="0">"Help"</a> section
                    for more information.</span>
                }
            </div>
            }
            
            @if (!currentAddSurveyError()) {
            <div class="mat-body-1">
                {{currentAddSurveyInfo()}}
                @if (!isHideHowDoIMsg()) {
                <span class="uscb-padding-L-8">Please visit the <a (click)="showHelpModal()" (keyup.enter)="showHelpModal()" tabindex="0">"Help"</a> section
                    for more information.</span>
                }
            </div>
            }

            <form [formGroup]="formGroup" class="uscb-layout-column uscb-layout-align-stretch-center uscb-form">
                @if (!isIE()) {
                <input #authCode formControlName="authCode" mask="AAAA-AAAA-AAAA" [showMaskTyped]="true"
                    aria-label="authCode" class="md-input input-blueborder uscb-width-100 uscb-padding-L-5" name="authCode" id="authCode"
                    type="text" placeholder="AUTHENTICATION CODE" (keyup.enter)="confirm()" (keyup)="fixCursorPos()"
                    (input)="authCode.value=$event.target.value.toUpperCase()" tabindex="0">
                }

                <input #begin class="ecorr-input-hidden" type="text" />

                @if (isIE()) {
                <input #authCode formControlName="authCode" aria-label="authCode"
                    class="md-input input-blueborder uscb-width-100 uscb-padding-L-5" name="authCode" id="authCode" type="text"
                    [placeholder]="iePlaceholder" (keyup.enter)="confirm()" (input)="fixIE($event)" (paste)="fixIE($event)" tabindex="0">
                }
            </form>
            <div class="mat-body-1">Authentication codes are not case sensitive.</div>
        </div>
    </mat-dialog-content>
    }

    @if (isSuccess()) {
    <div class="dialog-content-padding">
        <h4 class="xlg-text">Success! Your survey has been added!</h4>
        <span class="md-text top-padding">If you would like to share this survey with others in your organization, select "Share
            Survey Access" under 'OPTIONS' on your survey card.</span>
    </div>
    }

    @if (!isSuccess()) {
    <mat-dialog-actions
        class="uscb-layout-row-gt-md uscb-layout-column-md uscb-layout-column-sm uscb-layout-align-center-center">
        <button type="button" class="uscb-secondary-button uscb-flex-row uscb-margin-LR-10"
            (click)="cancel()" (keyup.enter)="cancel()" tabindex="0">{{addSurveyDialogData?.cancelButtonLabel || 'Cancel'}}</button>
        @if (!isAddSurveyButtonDisabled()) {
        <button type="button" [disabled]="formGroup.invalid" class="uscb-primary-button uscb-flex-row"
            (click)="confirm()" (keyup.enter)="confirm()" tabindex="0">{{addSurveyDialogData?.confirmButtonLabel || 'Begin'}}</button>
        }
        @if (isAddSurveyButtonDisabled()) {
        <button type="button" disabled class="uscb-primary-button uscb-flex-row">
            PLEASE WAIT... &nbsp;&nbsp; <i class="fa fa-spinner fa-spin fa-lg"></i>
        </button>
        }
    </mat-dialog-actions>
    }
    @if (isSuccess()) {
    <mat-dialog-actions
        class="uscb-layout-row-gt-md uscb-layout-column-md uscb-layout-column-sm uscb-layout-align-center-center">
        <button type="button" class="uscb-primary-button" (click)="cancel()" (keyup.enter)="cancel()" tabindex="0">OK</button>
    </mat-dialog-actions>
    }
</section>
